import { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Typography, Button } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'

const Item = styled(Paper)(() => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'block',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const thirteenToSeventeenPageFour = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  //UseProgress Context Hook
  const { updateProgress } = useProgress()
  updateProgress(85)

  const scrolltoTop = function () {
    window.scrollTo(0, 0)
  }

  //Scroll to top when page mounts
  useEffect(() => {
    scrolltoTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const {
    register,
    handleSubmit,
    setValue,
    formState: {},
  } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})
  const guardianType = SubmissionState.sectionOneForm?.relationshiptoPatient

  const setCardColor = function (color) {
    let SigCardSt = document.getElementsByClassName('Card')
    let SigPadBk = document.getElementsByClassName('SigPad')
    SigPadBk[0].style.backgroundColor = color
    SigCardSt[0].style.backgroundColor = color
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false), signData.current.clear(), setCardColor('#FAFAFA')
  }

  const save = () =>
    setImageURL(
      signData.current.getTrimmedCanvas().toDataURL('image/png'),
      setValue('imageURLStr', 'True'),
      setCardColor('#E8F0FE'),
      setIsSigned(true),
    )

  const saveIfNotEmpty = () => {
    if (signData.current.isEmpty()) {
      setIsSigned(false)
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    data.imageUrlGuardian = imageURL
    SubmissionState.secB = data
    SubmissionState.sectionFourForm = data
    SubmissionState.submitCompletedForm = true
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.goPageFour = false
    SubmissionState.goPageThree = true
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {
              xs: '1.25rem',
              sm: '1.25rem',
              md: '1.25rem',
              lg: '2rem',
              xl: '2rem',
            },
            marginBottom: {
              xs: '2rem',
              sm: '2rem',
              md: '2rem',
              lg: '2rem',
              xl: '2rem',
            },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; Patient Signature</IformBreadcrumb>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Item elevation={0}>
            <Typography variant="h1" style={{ marginLeft: 0, marginBottom: 24 }}>
              For Parent or Legal Guardian (Proxy)
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography variant="h2" style={{ marginLeft: -4, marginBottom: 16, fontSize: 20 }}>
              By signing below, I acknowledge and agree that:
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>
                  I must comply with the Terms and Conditions on the MyNorthwell Website to access the Teen’s
                  MyNorthwell account.
                </li>
                <li>
                  Access to MyNorthwell is provided by Northwell as a convenience to its patients and families and
                  Northwell may deactivate access to my MyNorthwell account at any time for any reason. A Teen may also
                  revoke Proxy access to his/her account at any time.
                </li>
                <li>
                  I understand that Proxy access will include select, limited medical information from a Teen’s medical
                  record. I may request a copy of my child’s full medical record through other means.
                </li>
                <li>
                  I understand that Proxy access to the Teen’s account will automatically terminate when the patient
                  reaches 18 years of age.
                </li>
                <li>
                  If I have been granted limited access, but would like expanded access at a later date, I and my Teen
                  must have a discussion together with my Teen’s Northwell provider.
                </li>
              </ul>
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography variant="h2" style={{ marginLeft: -4, marginBottom: 16, fontSize: 20 }}>
              I hereby certify that I am the parent or legal guardian of the Teen listed on this form and have the right
              to access my child’s health information. (Attach proof of legal guardianship if applicable.)
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  Signature required <span className="red"> *</span>
                </Typography>
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="Signature is required." /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveIfNotEmpty} type="submit" text="Submit" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="Reset Signature" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}
export default thirteenToSeventeenPageFour
